module.exports = __webpack_public_path__ + "img/logo-white-2a642acb6b7ceb83fae385c1c7524d5f.108ff6ac.png";